import { useElementScrollRestoration as useTanstackElementScrollRestoration } from '@tanstack/react-router';
import * as React from 'react';

/** In pixels. */
type ScrollPosition = { scrollX: number; scrollY: number };

/**
 * The position the router recorded on this history entry for the element marked `data-scroll-restoration-id={id}`:
 * on Back and Forward, where the user left it. The router restores scroll by itself once a page has rendered; this is
 * for an element whose content isn't there yet then, such as a virtualized list: hand it `scrollY` as its initial
 * offset. Put `id` on the element that scrolls, unique on the page, since the router records and restores by `id`.
 *
 * On a new entry it's `undefined`, unless the router carried the last page's position over, which it does for an
 * element `scrollToTopSelectors` doesn't name (see `scrollRestoration` in `createAppRouter`).
 */
export function useElementScrollRestoration({ id }: { id: string }): ScrollPosition | undefined {
    const entry = useTanstackElementScrollRestoration({ id });
    // The value at mount on purpose: later, the router has already moved the element itself.
    const [atMount] = React.useState(entry);
    return atMount;
}
